module.exports = __webpack_public_path__ + "img/13.7.Chla.d981750b.png";